import {
  DashboardHeader,
  TransparentDashboardHeader,
} from '@/views/Dashboard/Layout/Header'
import { EditOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Space, Typography } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { UserMenu } from './UserMenu'

export const Page = ({
  title = '',
  description = '',
  children,
  isEmbeded = false,
  onScroll = () => {},
  showTransparentHeader = false,
  breadcrumbItems = [],
  showEdit = false,
  onEdit = () => {},
}) => {
  const getBreadcrumb = (items) => {
    return items?.length > 0 ? (
      <Breadcrumb separator=">" style={{ marginBottom: '8px' }}>
        {items &&
          items?.map((item) => {
            return (
              <Breadcrumb.Item key={item?.label + Math.random()}>
                {item?.type == 'link' ? (
                  <Link to={item?.url}>{item.label}</Link>
                ) : (
                  item.label
                )}
              </Breadcrumb.Item>
            )
          })}
      </Breadcrumb>
    ) : (
      ''
    )
  }
  return (
    <div className="page">
      {title && !isEmbeded && (
        <div className="title-bar" style={{ flexDirection: 'column' }}>
          <div>{getBreadcrumb(breadcrumbItems)}</div>
          <Typography.Title level={3} className="dashboard-title">
            <Space>
              {title}
              {showEdit && (
                <Button type="link" onClick={onEdit}>
                  <EditOutlined />
                </Button>
              )}
            </Space>
          </Typography.Title>
          {description && (
            <div className="dashboard-sub-title">{description}</div>
          )}
        </div>
      )}
      {showTransparentHeader && <TransparentDashboardHeader />}
      <div className="page-content" onScroll={onScroll}>
        {children}
      </div>
    </div>
  )
}
